<style scoped lang="less">
.content {
  text-align: center;
  padding-top: 50px;
  h1 {
    font-size: 24px;
  }
}
</style>
<template>
  <div class="content">
    <img src="@/assets/image/build.png" />
    <h1>建设中。。。</h1>
  </div>
</template>
<script>
</script>